import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useLayoutEffect } from "react";
import { AzureAD, AuthenticationState } from 'react-aad-msal'; // JSS

import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { Row, Col } from "react-bootstrap"; // Design System

import Heading from '../heading/Heading';
import { RadioButton } from "../forms/elements/Radio";
import MediaQuery from "react-responsive";
import ImageLoader from '../images/ImageLoader';
import { SwatchDisplay } from "./SwatchDisplay";
import * as UTIL from "../../util"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { ecommAdd, ecommClick, selectItem } from '../../util';
import { uniq } from "lodash";
import { id } from "date-fns/locale";
import PegIcon from '../../images/svg/peg-icon.svg';
import { itemObject, useGTMDispatch } from "../../util";
export default (function (props) {
  var _link3$value4, _link3$value5, _link2$value, _link3$value6, _link3$value7;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      _props$saveDefault = props.saveDefault,
      saveDefault = _props$saveDefault === void 0 ? function () {
    return "";
  } : _props$saveDefault,
      _props$handleFavorite = props.handleFavorite,
      handleFavorite = _props$handleFavorite === void 0 ? function () {
    return "";
  } : _props$handleFavorite,
      isRetail = props.isRetail,
      isEditing = props.isEditing,
      isLoading = props.isLoading,
      _props$isPromoProduct = props.isPromoProduct,
      isPromoProduct = _props$isPromoProduct === void 0 ? false : _props$isPromoProduct;
  var _model$image = model.image,
      image = _model$image === void 0 ? {} : _model$image,
      _model$title = model.title,
      title = _model$title === void 0 ? {} : _model$title,
      _model$text = model.text,
      text = _model$text === void 0 ? {} : _model$text,
      _model$price = model.price,
      price = _model$price === void 0 ? {} : _model$price,
      _model$calorie = model.calorie,
      calorie = _model$calorie === void 0 ? {} : _model$calorie,
      _model$likes = model.likes,
      likes = _model$likes === void 0 ? {} : _model$likes,
      _model$available = model.available,
      available = _model$available === void 0 ? {} : _model$available,
      _model$link = model.link,
      link = _model$link === void 0 ? {} : _model$link,
      _model$link2 = model.link2,
      link2 = _model$link2 === void 0 ? {} : _model$link2,
      _model$link3 = model.link3,
      link3 = _model$link3 === void 0 ? {} : _model$link3,
      _model$defaultOptions = model.defaultOptions,
      defaultOptions = _model$defaultOptions === void 0 ? [] : _model$defaultOptions,
      tags = model.tags,
      _model$lighterFare = model.lighterFare,
      lighterFare = _model$lighterFare === void 0 ? null : _model$lighterFare,
      servingSize = model.servingSize,
      almostGoneBanner = model.almostGoneBanner,
      exclusiveBanner = model.exclusiveBanner,
      exclusiveText = model.exclusiveText,
      sku = model.sku,
      _model$isFavorite = model.isFavorite,
      isFavorite = _model$isFavorite === void 0 ? false : _model$isFavorite,
      productId = model.productId,
      _model$swatches = model.swatches,
      swatches = _model$swatches === void 0 ? [] : _model$swatches,
      variantsExist = model.variantsExist,
      noButton = model.noButton,
      optionsExist = model.optionsExist,
      isWishlistRetail = model.isRetail,
      isRetailSearch = model.isRetailSearch,
      advanceLeadtime = model.advanceLeadtime,
      pegPointsNeeded = model.pegPointsNeeded;

  var _useState = useState(isFavorite),
      _useState2 = _slicedToArray(_useState, 2),
      favorite = _useState2[0],
      setFavorite = _useState2[1];

  var _useState3 = useState(defaultOptions.length - 1),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedOption = _useState4[0],
      setSelectedOption = _useState4[1];

  var variantResults = "";

  if (variantsExist) {
    var _model$fullElement;

    var eachVariant = model === null || model === void 0 ? void 0 : (_model$fullElement = model.fullElement) === null || _model$fullElement === void 0 ? void 0 : _model$fullElement.Variants;
    var variantColors = eachVariant.filter(function (v) {
      return v.VariantProperties.Color;
    }).map(function (variantArray) {
      return variantArray.VariantProperties.Color;
    });
    var variantSizes = eachVariant.filter(function (v) {
      return v.VariantProperties.Size;
    }).map(function (variantArray) {
      return variantArray.VariantProperties.Size;
    });

    if (variantSizes != "") {
      variantResults = variantSizes;
    } else {
      variantResults = variantColors;
    }
  }

  var handlePassToCustomize = function handlePassToCustomize() {
    customizeClick();

    if (defaultOptions.length !== 1) {
      return saveDefault(defaultOptions[selectedOption]);
    }
  };

  var handleAddToOrder = function handleAddToOrder(e) {
    var _link3$value, _model$fullElement2, _ecommAdd;

    e.preventDefault();
    addToOrder(defaultOptions[selectedOption]);
    var data = {
      gtm: {
        uniqueEventId: 65,
        elementTarget: title.value,
        elementId: "addtoorder-".concat(sku || productId),
        productName: title.value || title
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    ecommAdd((_ecommAdd = {
      // NOTE: This is used to get categories
      detailLink: ((_link3$value = link3.value) === null || _link3$value === void 0 ? void 0 : _link3$value.href) || '',
      // addon_selected: null,
      affiliation: (model === null || model === void 0 ? void 0 : (_model$fullElement2 = model.fullElement) === null || _model$fullElement2 === void 0 ? void 0 : _model$fullElement2.CatalogName) || '',
      // byob_item: null,
      currency: 'USD',
      discount: 0,
      index: 0,
      sku: sku || productId,
      item_id: sku || productId,
      item_name: title.value || title,
      // item_list_name: itemListTitle.value,
      // item_list_id: itemListTitle.value,
      // item_variant: variantOptions,
      price: price.value || price,
      quantity: 1
    }, _defineProperty(_ecommAdd, "sku", sku || productId), _defineProperty(_ecommAdd, "value", price.value || price), _ecommAdd));
  };

  var wishlistHandler = function wishlistHandler() {
    var newFavorite = !favorite;
    setFavorite(newFavorite);
    handleFavorite(sku || productId, newFavorite);
    favoriteClick();
  };

  var favoriteClick = function favoriteClick() {
    var data = {
      gtm: {
        uniqueEventId: 61,
        elementTarget: title.value,
        elementId: "favorite-".concat(sku || productId),
        productName: title.value || title
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var customizeClick = function customizeClick() {
    var _model$fullElement3, _item, _link3$value2, _model$fullElement4;

    var data = {
      gtm: {
        uniqueEventId: 72,
        elementTarget: title.value,
        elementId: "customize-".concat(sku || productId)
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    ecommClick({
      item: (_item = {
        // addon_selected: null,
        affiliation: (model === null || model === void 0 ? void 0 : (_model$fullElement3 = model.fullElement) === null || _model$fullElement3 === void 0 ? void 0 : _model$fullElement3.CatalogName) || '',
        // byob_item: null,
        currency: 'USD',
        discount: 0,
        index: 0,
        sku: sku || productId,
        item_id: sku || productId,
        item_name: title.value || title,
        // item_list_name: itemListTitle.value,
        // item_list_id: itemListTitle.value,
        // item_variant: variantOptions,
        price: price.value || price,
        quantity: 1
      }, _defineProperty(_item, "sku", sku || productId), _defineProperty(_item, "value", price.value || price), _item),
      name: title.value || title,
      id: sku || productId,
      price: price.value || price,
      detailLink: ((_link3$value2 = link3.value) === null || _link3$value2 === void 0 ? void 0 : _link3$value2.href) || '',
      catalog: (model === null || model === void 0 ? void 0 : (_model$fullElement4 = model.fullElement) === null || _model$fullElement4 === void 0 ? void 0 : _model$fullElement4.CatalogName) || '',
      variants: variantResults || ''
    });
  };

  var featureClick = function featureClick(event) {
    var _model$fullElement5, _item2, _link3$value3, _model$fullElement6;

    var data = {
      gtm: {
        uniqueEventId: 76,
        elementTarget: title.value,
        elementId: "feature-".concat(sku || productId)
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    ecommClick({
      item: (_item2 = {
        // addon_selected: null,
        affiliation: (model === null || model === void 0 ? void 0 : (_model$fullElement5 = model.fullElement) === null || _model$fullElement5 === void 0 ? void 0 : _model$fullElement5.CatalogName) || '',
        // byob_item: null,
        currency: 'USD',
        discount: 0,
        index: 0,
        sku: sku || productId,
        item_id: sku || productId,
        item_name: title.value || title,
        // item_list_name: itemListTitle.value,
        // item_list_id: itemListTitle.value,
        // item_variant: variantOptions,
        price: price.value || price,
        quantity: 1
      }, _defineProperty(_item2, "sku", sku || productId), _defineProperty(_item2, "value", price.value || price), _item2),
      name: title.value || title,
      id: sku || productId,
      price: price.value || price,
      detailLink: ((_link3$value3 = link3.value) === null || _link3$value3 === void 0 ? void 0 : _link3$value3.href) || '',
      catalog: (model === null || model === void 0 ? void 0 : (_model$fullElement6 = model.fullElement) === null || _model$fullElement6 === void 0 ? void 0 : _model$fullElement6.CatalogName) || '',
      variants: variantResults || ''
    });
  };

  var FavoriteHeart = function FavoriteHeart(_ref) {
    var favorite = _ref.favorite,
        wishlistHandler = _ref.wishlistHandler,
        className = _ref.className,
        id = _ref.id;
    return /*#__PURE__*/React.createElement("button", {
      onClick: wishlistHandler,
      id: "favorite-".concat(id),
      className: "cb-button-unstyled cb-card__favorite ".concat(favorite ? "is-active" : "", " ").concat(className)
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "\n    cb-card\n    cb-card__food\n  "
  }, /*#__PURE__*/React.createElement(SitecoreLink, {
    className: "cb-card__image-container",
    field: {
      value: {
        href: noLocation ? "#" : (_link3$value4 = link3.value) === null || _link3$value4 === void 0 ? void 0 : _link3$value4.href
      }
    },
    onClick: handlePassToCustomize
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, Boolean(tags) && /*#__PURE__*/React.createElement("div", {
    className: "bookmark cb-type-caption"
  }, /*#__PURE__*/React.createElement("span", null, tags))), Boolean(almostGoneBanner) && /*#__PURE__*/React.createElement("div", {
    className: "bookmark almost-gone-banner cb-type-caption"
  }, /*#__PURE__*/React.createElement("span", null, "Almost Gone")), Boolean(exclusiveBanner) && /*#__PURE__*/React.createElement("div", {
    className: "bookmark exclusive-banner cb-type-caption"
  }, /*#__PURE__*/React.createElement("span", null, "Exclusive")), Boolean(sku) && /*#__PURE__*/React.createElement(FavoriteHeart, {
    favorite: favorite,
    id: sku,
    wishlistHandler: wishlistHandler,
    className: "cb-card__light-fare"
  }), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, lighterFare && /*#__PURE__*/React.createElement("span", {
    className: "cb-card__light-fare"
  })), /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: isEditing,
    media: image,
    type: 'product',
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-card__copy-container ".concat(noLocation ? "no-location" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__food-copy"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, Boolean(tags) && /*#__PURE__*/React.createElement("div", {
    className: "bookmark cb-type-caption"
  }, /*#__PURE__*/React.createElement("span", null, tags))), Boolean(servingSize) && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: {
      value: servingSize
    },
    className: "cb-card__food-avail cb-serves"
  }), Boolean(exclusiveText) && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: {
      value: "EXCLUSIVE"
    },
    className: "cb-card__food-avail cb-serves"
  }), /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        href: noLocation ? "#" : (_link3$value5 = link3.value) === null || _link3$value5 === void 0 ? void 0 : _link3$value5.href
      }
    },
    className: "cb-card__link",
    id: "feature-".concat(sku || productId),
    onClick: handlePassToCustomize
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: title,
    className: "cb-card__title"
  })), model.catalogName === 'eat' && pegPointsNeeded && pegPointsNeeded.points > 0 && /*#__PURE__*/React.createElement("div", {
    className: 'cb-card__peg-redemption'
  }, /*#__PURE__*/React.createElement("span", {
    className: "cb-card__peg-amount-to-redeem"
  }, "Redeem for"), /*#__PURE__*/React.createElement("div", {
    className: 'cb-card__peg-amount'
  }, /*#__PURE__*/React.createElement("span", {
    className: 'cb-card__peg-amount__text'
  }, pegPointsNeeded.points), /*#__PURE__*/React.createElement("img", {
    className: 'cb-card__peg-amount__icon',
    src: PegIcon
  }))), /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: text,
    className: "cb-type-body-sm"
  }), Boolean(sku) && /*#__PURE__*/React.createElement("div", {
    id: "powerReviews-sku-".concat(sku)
  }), defaultOptions.length !== 1 ? /*#__PURE__*/React.createElement(DefaultOptions, {
    selectedOption: selectedOption,
    setSelectedOption: setSelectedOption,
    defaultOptions: defaultOptions
  }) : null), /*#__PURE__*/React.createElement("div", {
    className: "cb-card__food-details--wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__food-details"
  }, /*#__PURE__*/React.createElement(SwatchDisplay, {
    swatches: uniq(swatches)
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "span",
    field: price,
    className: "cb-card__text"
  }), /*#__PURE__*/React.createElement(RichText, {
    tag: "span",
    field: calorie,
    className: "cb-card__text cb-card__cal"
  }), !Boolean(sku) && /*#__PURE__*/React.createElement(FavoriteHeart, {
    favorite: favorite,
    id: productId,
    wishlistHandler: wishlistHandler,
    className: "cb-card__like"
  })), available.value && !isRetailSearch && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: available,
    className: "cb-card__food-avail"
  }), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, lighterFare && /*#__PURE__*/React.createElement("span", {
    className: "cb-card__light-fare"
  }))), advanceLeadtime != null && /*#__PURE__*/React.createElement("p", {
    className: "cb-card__leadTime"
  }, advanceLeadtime), Boolean(((_link2$value = link2.value) === null || _link2$value === void 0 ? void 0 : _link2$value.href) || ((_link3$value6 = link3.value) === null || _link3$value6 === void 0 ? void 0 : _link3$value6.href)) && !noButton && !noLocation && /*#__PURE__*/React.createElement(Row, {
    className: "cb-card__button-group-parent"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Row, {
    className: "cb-card__food-button-group"
  }, isWishlistRetail ? Boolean((_link3$value7 = link3.value) === null || _link3$value7 === void 0 ? void 0 : _link3$value7.href) && /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(SitecoreLink, {
    className: "cb-button-primary",
    onClick: handlePassToCustomize,
    id: "viewdetail-".concat(sku || productId),
    field: link3
  })) : /*#__PURE__*/React.createElement(ProductCardButtonGroup, {
    link2: link2,
    link3: link3,
    optionsExist: optionsExist,
    defaultOptions: defaultOptions,
    handleAddToOrder: handleAddToOrder,
    handlePassToCustomize: handlePassToCustomize,
    sku: sku,
    isLoading: isLoading,
    productId: productId
  }))))));
});

var ProductCardButtonGroup = function ProductCardButtonGroup(_ref2) {
  var _link2$value2, _defaultOptions$, _defaultOptions$$opti, _link3$value8, _defaultOptions$2, _defaultOptions$2$opt;

  var link2 = _ref2.link2,
      link3 = _ref2.link3,
      optionsExist = _ref2.optionsExist,
      defaultOptions = _ref2.defaultOptions,
      handleAddToOrder = _ref2.handleAddToOrder,
      handlePassToCustomize = _ref2.handlePassToCustomize,
      sku = _ref2.sku,
      productId = _ref2.productId,
      isLoading = _ref2.isLoading;
  var styling = "cb-button-primary" + (Boolean(isLoading) ? ' is-fetching' : ' ');
  return /*#__PURE__*/React.createElement(Col, null, Boolean((_link2$value2 = link2.value) === null || _link2$value2 === void 0 ? void 0 : _link2$value2.href) && Boolean(!optionsExist && !((_defaultOptions$ = defaultOptions[0]) === null || _defaultOptions$ === void 0 ? void 0 : (_defaultOptions$$opti = _defaultOptions$.options) === null || _defaultOptions$$opti === void 0 ? void 0 : _defaultOptions$$opti.length)) && /*#__PURE__*/React.createElement(SitecoreLink, {
    className: styling,
    onClick: handleAddToOrder,
    field: link2
  }), Boolean((_link3$value8 = link3.value) === null || _link3$value8 === void 0 ? void 0 : _link3$value8.href) && Boolean(optionsExist || ((_defaultOptions$2 = defaultOptions[0]) === null || _defaultOptions$2 === void 0 ? void 0 : (_defaultOptions$2$opt = _defaultOptions$2.options) === null || _defaultOptions$2$opt === void 0 ? void 0 : _defaultOptions$2$opt.length)) && /*#__PURE__*/React.createElement(SitecoreLink, {
    className: styling,
    onClick: handlePassToCustomize,
    id: "customize-".concat(sku || productId),
    field: link3
  }));
};

var DefaultOptions = function DefaultOptions(_ref3) {
  var selectedOption = _ref3.selectedOption,
      setSelectedOption = _ref3.setSelectedOption,
      defaultOptions = _ref3.defaultOptions;

  var handleChange = function handleChange(index) {
    setSelectedOption(index);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "cb-cart__defaults"
  }, defaultOptions.map(function (option, index) {
    var storeProductId = option.storeProductId,
        optionLabel = option.optionLabel;
    var title = storeProductId + "" + index;
    var isChecked = selectedOption.toString() === index.toString();
    return /*#__PURE__*/React.createElement(DefaultOptionsMarkUp, {
      key: index,
      productId: storeProductId,
      title: title,
      index: index,
      isChecked: isChecked,
      optionLabel: optionLabel,
      cost: option.cost,
      handleChange: handleChange
    });
  }));
};

var DefaultOptionsMarkUp = function DefaultOptionsMarkUp(_ref4) {
  var productId = _ref4.productId,
      title = _ref4.title,
      index = _ref4.index,
      isChecked = _ref4.isChecked,
      optionLabel = _ref4.optionLabel,
      defaultNoSides = _ref4.defaultNoSides,
      handleChange = _ref4.handleChange,
      cost = _ref4.cost;
  var labelClass = isChecked ? "is-active" : "";
  return /*#__PURE__*/React.createElement(RadioButton, {
    name: productId,
    id: title,
    value: index,
    checked: isChecked,
    onClick: function onClick() {
      return handleChange(index);
    },
    onChange: function onChange() {
      return handleChange(index);
    },
    className: "cb-type-body-sm ".concat(index === 0 ? "pt-12" : ""),
    labelClass: labelClass
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cb-cart__item__copy"
  }, /*#__PURE__*/React.createElement("span", null, optionLabel + ":  "), "$" + cost));
};